import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ListItem } from 'src/app/core/models/ui/list-item.interface';
import { ListSelectionDialogData } from 'src/app/core/models/dialog-data/list-selection-dialog-data.interface';

@Component({
  selector: 'app-list-selection-dialog',
  templateUrl: './list-selection-dialog.component.html',
  styleUrls: ['./list-selection-dialog.component.scss'],
})
export class ListSelectionDialogComponent {
  selectedItem: ListItem | undefined;
  filterText: string = '';

  constructor(
    public dialogref: MatDialogRef<ListSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ListSelectionDialogData
  ) {}

  onCancelClick() {
    this.dialogref.close();
  }

  onOkClicked() {
    this.dialogref.close(
      this.data.multiSelect ? this.data.selectedItems : this.selectedItem
    );
  }

  onItemClicked(item: ListItem) {
    if (!this.data.multiSelect) {
      // if (this.selectedItem) {
      //   this.selectedItem = undefined;
      // } else {
      //   this.selectedItem = item;
      // }
      this.selectedItem = item;
      return;
    }

    const itemIndex = this.data.selectedItems.indexOf(item);
    if (itemIndex) {
      this.data.selectedItems.splice(itemIndex, 1);
    } else {
      this.data.selectedItems.push(item);
    }
  }

  getFilteredItems() {
    return this.data.items.filter((item) =>
      item.description.toLowerCase().includes(this.filterText.toLowerCase())
    );
  }
}
